// this file is generated by update_shopify_store_data.py at 2026-11-03 20:12:28.736994
var courses = [
    {
        "course_id": "81FC80A7-6184-F111-99B5-005056A74645",
        "course_version": 1,
        "name": "ANA: APRN Pharmacology Today: Neurodegenerative Diseases",
        "course_type": 1,
        "author_information": "",
        "description": "Neurodegenerative diseases pose increasing clinical and therapeutic complexity. This evidence-based online course synthesizes key pharmacologic mechanisms, current therapies, and emerging treatment strategies for Alzheimer\u2019s disease & dementia, Parkinson\u2019s disease, and multiple sclerosis. Designed for APRNs, it emphasizes practical, patient-centered prescribing and monitoring to optimize safety and outcomes across disease stages.",
        "learning_objectives_html": "<p>Upon completion of this activity, participants will be able to:</p>\r\n<ul>\r\n    <li>Differentiate the core neurodegenerative mechanisms and clinical profiles of neurodegenerative diseases.</li>\r\n    <li>Evaluate current evidence-based pharmacologic therapies.</li>\r\n    <li>Apply individualized medication management strategies across diverse care settings.</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D089F81-80D3-EF11-9991-005056A78EAA",
                "course_category_name": "ANA - ANA APRN Pharmacology Bundle - Courses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "41A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pharmacology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C98E2D7E-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Anesthetist",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
            "course_level_accreditation_statement": "",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 4.0,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];